/* eslint-disable prettier/prettier */
// project import
import dashboard from '../../../../../menu-items/dashboard';
import companies from '../../../../../menu-items/comapanies';
import Users from '../../../../../menu-items/employees';
import Movements from '../../../../../menu-items/movement';
import Permissions from '../../../../../menu-items/permission';
import project from '../../../../../menu-items/project';
import analytics from '../../../../../menu-items/analytics';
import subscription from '../../../../../menu-items/subscription';
import client_subscription from '../../../../../menu-items/clientSubscription';
import OrganizationStructure from '../../../../../menu-items/functions';
import MenuStatus from '../../../../../menu-items/menuStatus';
import axios from 'lib/axios';
import { Box, Typography } from '@mui/material';
import Feedback from '../../../../../menu-items/feedback';
// project import
import NavGroup from './NavGroup';
import { useState, useEffect } from 'react';
// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSupervisor, setIsSupervisor] = useState(false);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.post(`/users/user`, {
                    id: JSON.parse(localStorage.getItem('authUser'))?.user_id
                });
                const user = response.data.data;
                if (user.role_id === 1) {
                    setIsSuperAdmin(true);
                } else if (user.is_admin || user.role?.role_type?.toLowerCase() === 'admin') {
                    setIsAdmin(true);
                }
            } catch (error) {
                console.log(error.message);
            }
        };
        fetchUserData();
        // HasPermission(setIsSuperAdmin, 'Company', 'create', 'create_company');
        if (isSuperAdmin) {
            setItems([dashboard, companies, subscription, Permissions, Feedback]);
        } else if (isAdmin) {
            setItems([dashboard, Users, OrganizationStructure, MenuStatus, analytics, client_subscription]);
        }

        if (isSupervisor && !isAdmin) {
            setItems([dashboard]);
        }
    }, [isAdmin, isSuperAdmin, isSupervisor]);

    const navGroups = items?.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Fix - Navigation Group
                    </Typography>
                );
        }
    });

    return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
